// extracted by mini-css-extract-plugin
export default {"container":"LoadingSpinner_container__m3LMO","spinner":"LoadingSpinner_spinner__CqAUt","spin":"LoadingSpinner_spin__Ze3ns","message":"LoadingSpinner_message__2-pPp"};